import React from "react";
import HomePage from "./components/home/HomePage";

function AboutMeApp() {
  return <HomePage />;
}
export default AboutMeApp;
